document.addEventListener('DOMContentLoaded', function () {
    const mobileNavLinks = document.querySelectorAll('.collapse-pdp .mobile-nav__link');
  
    mobileNavLinks.forEach(function (button) {
      button.addEventListener('click', function () {
        toggleCollapse(button);
      });
    });
  
    if (mobileNavLinks.length > 0) {
      mobileNavLinks[0].setAttribute('aria-expanded', 'true');
      for (let i = 1; i < mobileNavLinks.length; i++) {
        mobileNavLinks[i].setAttribute('aria-expanded', 'false');
      }
    }
});
  
function toggleCollapse(clickedButton) {
    const collapsePdp = clickedButton.closest('.collapse-pdp');
    const collapsibleContent = collapsePdp.querySelector('collapsible-content');

    const isAlreadyOpen = collapsibleContent.hasAttribute('open');

    const allCollapsibleContents = document.querySelectorAll('.collapse-pdp collapsible-content');
    allCollapsibleContents.forEach(function (otherCollapsibleContent) {
    otherCollapsibleContent.removeAttribute('open');
    });

    if (!isAlreadyOpen) {
    collapsibleContent.setAttribute('open', 'true');
    }

    const allMobileNavLinks = document.querySelectorAll('.collapse-pdp .mobile-nav__link');
    allMobileNavLinks.forEach(function (button) {
    button.setAttribute('aria-expanded', (button === clickedButton && !isAlreadyOpen).toString());
    });
    
}